import { Control, Controller, FieldPath } from 'react-hook-form';
import cl from 'classnames';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { IsDisabled } from '../../../../../../../types';
import { TaskStatuses } from '../../../../../tasksTypes';

import { PureIconButtonHelper } from '../../../../../../../helpers/buttons/PureIconButtonHelper';

import { words, statusesKeys } from '../../../../../../../locales/keys';

const activeButtonClassName =
  'border-blue-200 dark:border-transparent bg-blue-100 hover:bg-blue-50 text-black';

const inactiveButtonClassName =
  'border-gray-300 dark:border-gray-700 hover:bg-gray-500/10 text-gray-700 dark:text-gray-300';

interface RevisionTaskStatusButtonsFieldProps<T> {
  control: Control<T>;
  name: FieldPath<T>;
  disabled?: IsDisabled;
}

function RevisionTaskStatusButtonsField<T>({
  control,
  name,
  disabled
}: RevisionTaskStatusButtonsFieldProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <div className="flex flex-wrap gap-2">
          <PureIconButtonHelper
            className={cl(
              'border rounded text-sm flex items-center h-8 box-content',
              value === TaskStatuses.IN_PROGRESS
                ? activeButtonClassName
                : inactiveButtonClassName
            )}
            disabled={disabled}
            icon={IconsEnum.PLAY_SOLID}
            iconClassName="-mr-2 ml-2 h-4 w-4"
            i18nText={statusesKeys.types.implementation}
            i18nTextClassName="px-3 whitespace-nowrap"
            onClick={() => onChange(TaskStatuses.IN_PROGRESS)}
          />

          <PureIconButtonHelper
            className={cl(
              'border rounded text-sm flex items-center h-8 box-content',
              value === TaskStatuses.PAUSED
                ? activeButtonClassName
                : inactiveButtonClassName
            )}
            disabled={disabled}
            icon={IconsEnum.PAUSE_SOLID}
            iconClassName="-mr-2 ml-2 h-4 w-4"
            i18nText={words.pause}
            i18nTextClassName="px-3 whitespace-nowrap"
            onClick={() => onChange(TaskStatuses.PAUSED)}
          />

          <PureIconButtonHelper
            className={cl(
              'border rounded text-sm flex items-center h-8 box-content',
              value === TaskStatuses.PENDING_MORE_INFO
                ? activeButtonClassName
                : inactiveButtonClassName
            )}
            disabled={disabled}
            icon={IconsEnum.QUESTION_MARK_CIRCLE_SOLID}
            iconClassName="-mr-2 ml-2 h-4 w-4"
            i18nText="PMI"
            i18nTextClassName="px-3 whitespace-nowrap"
            onClick={() => onChange(TaskStatuses.PENDING_MORE_INFO)}
          />
        </div>
      )}
    />
  );
}

export default RevisionTaskStatusButtonsField;
